export function hasWhalarDomain(redirectUrl: string): boolean {
  return /^https?:\/\/([a-zA-Z\d-]+\.){0,}(localhost(:\d*)?|((whalar|usefoam)\.com|foam\.io))/.test(
    redirectUrl
  );
}
